export const gitCommit = 'd5bbac25'
